export const PLAN_GENERATION_PROFILES = ['Standard', 'DayHike', 'LongItinerary'] as const

export type PlanGenerationProfile = (typeof PLAN_GENERATION_PROFILES)[number]

// LongItinerary needs whole-trip totals that only popular hikes carry, so tours never offer it.
export const TOUR_PLAN_GENERATION_PROFILES = ['Standard', 'DayHike'] as const satisfies readonly PlanGenerationProfile[]

export type TourPlanGenerationProfile = (typeof TOUR_PLAN_GENERATION_PROFILES)[number]

export const DEFAULT_PLAN_GENERATION_PROFILE: TourPlanGenerationProfile = 'Standard'

export const planGenerationProfileLabel = (profile: PlanGenerationProfile) => {
  if (profile === 'DayHike') return 'Day hike'
  if (profile === 'LongItinerary') return 'Long Itinerary'
  return 'Standard'
}

export const parsePlanGenerationProfile = (value?: string | null): PlanGenerationProfile | null => {
  const normalized = value?.trim().replace(/[\s_-]+/g, '').toLowerCase()
  if (!normalized) return null
  if (normalized === 'standard') return 'Standard'
  if (normalized === 'dayhike') return 'DayHike'
  if (normalized === 'longitinerary') return 'LongItinerary'
  return null
}

export const isTourPlanGenerationProfile = (profile?: PlanGenerationProfile | null): profile is TourPlanGenerationProfile =>
  profile === 'Standard' || profile === 'DayHike'

/** Coerces a stored profile to one a tour can use, falling back to the default. */
export const toTourPlanGenerationProfile = (profile?: PlanGenerationProfile | null): TourPlanGenerationProfile =>
  isTourPlanGenerationProfile(profile) ? profile : DEFAULT_PLAN_GENERATION_PROFILE

/** Parses a tour CSV cell; profiles that are popular-hike-only (LongItinerary) are rejected. */
export const parseTourPlanGenerationProfile = (value?: string | null): TourPlanGenerationProfile | null => {
  const profile = parsePlanGenerationProfile(value)
  return isTourPlanGenerationProfile(profile) ? profile : null
}
